import styled from 'styled-components';

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(20, 16, 14, 0.94);
  backdrop-filter: blur(6px);
  z-index: 9999;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
`;

const Box = styled.div`
  text-align: center;
  padding: 2.5rem;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.14);
  max-width: 560px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.28);
`;

const Badge = styled.div`
  display: inline-block;
  padding: 0.4rem 0.8rem;
  border-radius: 999px;
  background: #8b1e2d;
  color: #fff;
  font-size: 0.85rem;
  font-weight: 700;
  margin-bottom: 1rem;
`;

const Title = styled.h1`
  color: #fff;
  font-size: clamp(1.8rem, 4vw, 2.4rem);
  margin-bottom: 1rem;
`;

const Text = styled.p`
  color: rgba(255, 255, 255, 0.86);
  line-height: 1.7;
  margin-bottom: 1rem;
`;

const ContactLink = styled.a`
  color: #fff;
  font-weight: 700;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const Button = styled.button`
  margin-top: 1.4rem;
  padding: 0.85rem 1.4rem;
  border: 0;
  border-radius: 999px;
  background: #8b1e2d;
  color: #fff;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.25);

  &:hover {
    background: #a6293a;
  }
`;

function MaintenanceOverlay({ onClose }) {
  const handlePreview = () => {
    sessionStorage.setItem('stadtheurigerMaintenancePreview', 'true');

    if (onClose) {
      onClose();
    }
  };

  return (
    <Overlay>
      <Box>
        <Badge>Wartungsmodus</Badge>
        <Title>Website in Vorbereitung</Title>
        <Text>
          Der Stadtheuriger zum Brückl ist hier in Kürze erreichbar.
          Reservierungen sind weiterhin telefonisch oder per E-Mail möglich.
        </Text>
        <Text>
          <ContactLink href="tel:+436703504707">0670 / 3504707</ContactLink>
          {' · '}
          <ContactLink href="mailto:office@stadtheuriger-neunkirchen.at">
            office@stadtheuriger-neunkirchen.at
          </ContactLink>
        </Text>

        <Button type="button" onClick={handlePreview}>
          Vorschau öffnen
        </Button>
      </Box>
    </Overlay>
  );
}

export default MaintenanceOverlay;